import { render, staticRenderFns } from "./CopyToClipboardText.vue?vue&type=template&id=036be7b4&"
import script from "./CopyToClipboardText.vue?vue&type=script&lang=js&"
export * from "./CopyToClipboardText.vue?vue&type=script&lang=js&"
import style0 from "./CopyToClipboardText.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports